import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import media from '../api/media.json'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      groups: [
        { id: 'norr', name: 'Norrort' },
        { id: 'nord', name: 'Nordost' },
        { id: 'vas', name: 'Västerort' },
        { id: 'inn', name: 'Innerstan' },
        { id: 'sod', name: 'Söderort' },
        { id: 'ss', name: 'Södra sidan' },
        { id: 'ebh', name: 'Enköping/Håbo/Upplands Bro' },
        { id: 'jar', name: 'Järfälla' },
        { id: 'dir', name: 'Hela Storstockolm' },
        { id: 'gbg', name: 'Göteborg'}
      ],
      media: media,
      products: [
        { id: 1, selectedFormat: null, device: 'desktop', name: 'Panorama', formats: [{ size: '980x240', price: 280 }], selected: false },
        { id: 2, selectedFormat: null, device: 'desktop', name: 'Outsider', formats: [{ size: '250x250', price: 150 }, { size: '250x600', price: 200 }, { size: '250x400', price: 175 }], selected: false },
        { id: 3, selectedFormat: null, device: 'desktop', name: 'MPU', formats: [{ size: '480x280', price: 140 }], selected: false },
        { id: 4, selectedFormat: null, device: 'desktop', name: 'Helsida', formats: [{ size: '1920x1080', price: 1200 }], selected: false },
        { id: 5, selectedFormat: null, device: 'mobile', name: 'Panorama', formats: [{ size: '320x320', price: 280 }, { size: '320x160', price: 220 }], selected: false },
        { id: 6, selectedFormat: null, device: 'mobile', name: 'Helsida', formats: [{ size: '1080x1920', price: 600 }], selected: false }
      ]
    },
    actions,
    mutations,
    getters
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js